import { render, staticRenderFns } from "./SNumber.vue?vue&type=template&id=98dcc2a4&scoped=true&"
import script from "./SNumber.vue?vue&type=script&lang=js&"
export * from "./SNumber.vue?vue&type=script&lang=js&"
import style0 from "./SNumber.vue?vue&type=style&index=0&id=98dcc2a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98dcc2a4",
  null
  
)

export default component.exports